import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8011';

const PersonCards = () => {
  const [persons, setPersons] = useState([]);

  useEffect(() => {
    const fetchLedger = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/ledger/getCompleteLedger`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch ledger');
        }

        const data = await response.json();
        if (Array.isArray(data)) {
          const personMap = data.reduce((acc, ledger) => {
            if (!acc[ledger.person]) {
              acc[ledger.person] = 0;
            }
            acc[ledger.person] += ledger.balance;
            return acc;
          }, {});

          const persons = Object.entries(personMap).map(([person, total]) => ({
            person,
            total,
          }));
          setPersons(persons);
        } else {
          throw new Error('Ledger data is not an array');
        }
      } catch (error) {
        console.error('Error fetching ledger:', error);
      }
    };

    fetchLedger();
  }, []);

  return (
    <div>
      <div>
        <h2 className="text-2xl font-semibold bg-themeColor2 p-3 rounded-lg text-themeColor1">Persons</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2 my-2">
        {persons.map((per, index) => (
          <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="p-4">
              <h3 className="text-xl font-semibold text-themeColor1">{per.person}</h3>
              <p className={`font-semibold ${per.total < 0 ? 'negative' : 'positive'}`}>
                Rs. {per.total.toFixed(2)}
              </p>
            </div>
            <div className="bg-gray-100 p-4 text-center">
              <Link to={`/person/${per.person}`} className="text-themeColor1 hover:underline hover:text-themeColor2">
                View More <i className="fa fa-arrow-circle-right"></i>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PersonCards;
